import { Button } from '@fluentui/react-components'
import styles from './ErrorBanner.module.scss'

interface ErrorBannerProps {
  title?: string
  message: string
  actionLabel?: string
  onAction?: () => void
}

export function ErrorBanner({
  title = 'Something went wrong',
  message,
  actionLabel,
  onAction,
}: ErrorBannerProps) {
  return (
    <div className={styles.banner} role="alert">
      <div>
        <span className={styles.title}>{title}</span>
        <div className={styles.body}>{message}</div>
      </div>
      {actionLabel && onAction ? (
        <Button appearance="secondary" onClick={onAction}>
          {actionLabel}
        </Button>
      ) : null}
    </div>
  )
}
